import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useTranslation } from "react-i18next";

interface ErrorFallbackProps {
  onReset?: () => void;
}

export function ErrorFallback({ onReset }: ErrorFallbackProps) {
  const { t } = useTranslation(["error", "common"]);

  const handleReset = () => {
    if (onReset) {
      onReset();
    } else {
      window.location.reload();
    }
  };

  return (
    <div className="min-h-screen bg-background p-10 lg:p-12 flex items-center justify-center">
      <div className="mx-auto max-w-md w-full">
        <Card className="p-6">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-destructive mb-2">
              {t("error:errorBoundary.title")}
            </h2>
            <p className="text-muted-foreground mb-6">
              {t("error:errorBoundary.description")}
            </p>
            <Button onClick={handleReset} variant="outline">
              {t("error:errorBoundary.tryAgain")}
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
}
